<template>
    <div>
      <div class="header-width divcss5">
         <productdetailbanner></productdetailbanner>
      </div>
      <!-- <div class=" row body-width divcss5">
        <productpartcontent style="padding-top: 50px"></productpartcontent>
      </div> -->
      <div class=" row body-width divcss5">
        <productheader></productheader>
      </div>
      <!-- <div class=" row body-width divcss5">
        <productcp></productcp>
      </div> -->
         <!-- <div class=" row body-width divcss5">
        <productqrw></productqrw>
      </div> -->
      <div class=" row body-width divcss5">
        <router-view />
        </div>
    </div>
</template>
<script>
  import productheader from "@/components/contentcoms/prodecutcontentcoms/productheader";
  import productcp from "@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productcp";
  import productqrw from "@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productqrw";
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  export default {
    name: "aboutcontent",
    components: {
      productdetailbanner,
      productheader,
      productcp,
      productqrw
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/producthhmnq.vue